// extracted by mini-css-extract-plugin
export var addButton = "_hf-0";
export var border = "_hf-8";
export var check = "_hf-h";
export var danger = "_hf-6";
export var dropdownContainer = "_hf-1";
export var editModalBody = "_hf-j";
export var footerContainer = "_hf-i";
export var fullWidth = "_hf-a";
export var hide = "_hf-9";
export var icon = "_hf-3";
export var input = "_hf-7";
export var inputFlex = "_hf-b";
export var inputWrapper = "_hf-c";
export var manualFocus = "_hf-5";
export var optionButton = "_hf-4";
export var pillWrapper = "_hf-e";
export var pointer = "_hf-2";
export var showOverflow = "_hf-f";
export var tagsFlex = "_hf-d";
export var xButton = "_hf-g";